module.exports = __webpack_public_path__ + "img/good.fdb78776.svg";